import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Select } from 'components/Select';

import * as S from './Pagination.styles';

type PaginationProps = {
  canPreviousPage: boolean;
  canNextPage: boolean;
  gotoPage: (updater: number | ((pageIndex: number) => number)) => void;
  previousPage: () => void;
  nextPage: () => void;
  pageIndex: number;
  pageOptions: number[];
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  tableName?: string;
};

const defaultProps: Partial<PaginationProps> = {};

export function Pagination(props: PaginationProps): React.ReactElement {
  const {
    canPreviousPage,
    canNextPage,
    gotoPage,
    previousPage,
    nextPage,
    pageIndex,
    pageOptions,
    pageSize,
    setPageSize,
    tableName,
  } = {
    ...defaultProps,
    ...props,
  };

  const sortingSizes = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];
  const sortingSizesMapped = sortingSizes.map((size) => ({ value: size, label: size }));
  const pageOptionsMapped = pageOptions.map((page) => ({
    value: page,
    label: page + 1,
  }));
  const defaultSortingSize = { value: pageSize, label: pageSize };
  const defaultPage = { value: pageIndex, label: pageIndex + 1 };

  return (
    <S.Pagination>
      <S.Container>
        <Headline scale="xs" color="borderColorDarkSecondary">
          View
        </Headline>

        <Select
          hasMaxMenuHeight
          options={sortingSizesMapped}
          defaultValue={defaultSortingSize}
          onChange={(e) => {
            setPageSize(Number(e.value));
          }}
        />

        <Headline scale="xs" color="borderColorDarkSecondary">
          {tableName} per page
        </Headline>
      </S.Container>

      <S.Container>
        <Button
          iconLeft="FiChevronLeft"
          motive="pagination"
          fontFamily="LFT Zeno"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          Prev
        </Button>

        <S.Container>
          <Headline scale="xs" color="borderColorDarkSecondary">
            Page
          </Headline>

          <Select
            hasMaxMenuHeight
            options={pageOptionsMapped}
            defaultValue={defaultPage}
            selectedValue={defaultPage}
            onChange={(e) => {
              gotoPage(e.value);
            }}
          />

          <Headline scale="xs" color="borderColorDarkSecondary">
            of {pageOptions.length}
          </Headline>
        </S.Container>

        <Button
          iconRight="FiChevronRight"
          motive="pagination"
          fontFamily="LFT Zeno"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          Next
        </Button>
      </S.Container>
    </S.Pagination>
  );
}
